var map = {
	"./components/sims-catalog/sims-catalog.module.ngfactory": [
		"./src/app/components/sims-catalog/sims-catalog.module.ngfactory.js",
		"default~components-leads-leads-module-ngfactory~components-sims-catalog-sims-catalog-module-ngfactor~8e708886",
		"default~components-leads-leads-module-ngfactory~components-sims-catalog-sims-catalog-module-ngfactor~a95f694e",
		"default~components-sims-catalog-sims-catalog-module-ngfactory~imei-lock-imei-lock-module-ngfactory~i~f728d0e5",
		"default~automatic-debit-automatic-debit-module-ngfactory~components-product-catalog-product-catalog-~4f378430",
		"default~components-selfcare-selfcare-module-ngfactory~components-sims-catalog-sims-catalog-module-ng~f8f81d18",
		"default~components-leads-leads-module-ngfactory~components-sims-catalog-sims-catalog-module-ngfactor~f0a317d2",
		"default~automatic-debit-automatic-debit-module-ngfactory~components-product-catalog-product-catalog-~0ab77279",
		"default~components-sims-catalog-sims-catalog-module-ngfactory~sim-repo-sim-repo-module-ngfactory",
		"common",
		"components-sims-catalog-sims-catalog-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;